"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const partners = [{
  name: "National Institute of Standards",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580361/img/partner_nist_logo.png"
}, {
  name: "Department of Energy Research",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580361/img/partner_doe_logo.png"
}, {
  name: "State University Research Center",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580361/img/partner_state_uni_logo.png"
}, {
  name: "Global Policy Institute",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580361/img/partner_global_policy_logo.png"
}, {
  name: "Defense Advanced Research",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580361/img/partner_darpa_logo.png"
}];
export default function InstitutionalPartners() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="institutional-partners" className="bg-background py-24 overflow-hidden">
      <div ref={ref} className={`container mx-auto px-6 md:px-12 max-w-7xl transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <h2 className="text-center text-2xl md:text-3xl font-bold text-foreground mb-16 font-sans tracking-tight">
          Our Academic & Institutional Research Partners
        </h2>
        
        <div className="flex flex-wrap justify-center items-center gap-20">
          {partners.map((partner, i) => <div key={i} data-index={i} className="flex items-center justify-center">
              <img src={partner.logo} alt={partner.name} className="h-12 w-auto object-contain grayscale opacity-60 hover:grayscale-0 hover:opacity-100 transition-all duration-300 ease-in-out" />
            </div>)}
        </div>
      </div>
    </section>;
}